import EnrolmentsSerializer from './base';

export default class Enrolment extends EnrolmentsSerializer {}
